import React from 'react';
import { StyledConclusion } from './MoConclusion.style';

const MoConclusion = () => {
    return ( 
        <StyledConclusion>Having an everlasting impact on the face of men's health.</StyledConclusion>
     );
}
 
export default MoConclusion;